import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  commentContent: {
    display: "flex",
    width: "100%",
  },

  commentInput: {
    alignSelf: "center",
    background: "transparent",
    border: "0",
    color: colors.gray500,
    flex: 1,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.25px",
    lineHeight: "20px",
    maxHeight: "200px",
    overflow: "auto !important",
    padding: "0",
    resize: "none",
    width: "100%",
  },

  content: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    padding: "24px",
    width: "100%",
    flexShrink: 0,
  },

  form: {
    alignItems: "flex-start",
    display: "flex",
    flex: "1 0 0",
    flexDirection: "column",
    gap: "4px",
  },

  formField: {
    background: colors.white,
    border: `1px solid ${colors.gray300}`,
    borderRadius: "8px",
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    padding: "12px 12px 12px 16px",
    width: "100%",

    "&:hover": {
      borderColor: colors.gray400,
    },

    "&:focus-within": {
      borderColor: colors.brandBlue500,
    },
  },

  formFieldError: {
    borderColor: `${colors.error600} !important`,
    caretColor: colors.error600,
  },

  sendButton: {
    alignSelf: "flex-end",
    background: colors.success500,
    borderRadius: "8px",
    height: "36px",
    padding: "4px",
    width: "36px",

    "&:hover": {
      background: colors.success500,
      filter: "brightness(125%)",
    },

    "&:disabled": {
      background: colors.gray200,
    },
  },

  supportContent: {
    alignContent: "flex-start",
    alignItems: "flex-start",
    alignSelf: "stretch",
    color: colors.gray500,
    display: "flex",
    flexWrap: "wrap",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    gap: "24px",
    justifyContent: "space-between",
    letterSpacing: "0.4px",
    lineHeight: "16px",
    padding: "0px 4px",
  },

  supportContentError: {
    color: colors.error600,
  },

  supportContentLeft: {
    display: "inline-flex",
    gap: "24px",
  },

  supportContentRight: {
    fontWeight: 700,
    letterSpacing: "0.4px",
  },

  userAvatar: {
    borderRadius: "50%",
    height: "32px",
    objectFit: "cover",
    width: "32px",
  },
}));

export default styles;
